import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FHEContainer } from 'data/components';
import { Toastr } from 'data/common';
import FormNotification from './Form/FormNotification';
import { addNotification, getDefaultNotificationsButtons } from '../../data/Notifications/actions';

class NotificationAdd extends PureComponent {
    static propTypes = {
        location: PropTypes.object.isRequired,
        defaultButtons: PropTypes.object.isRequired,
        getDefaultNotificationsButtons: PropTypes.func.isRequired,
        addNotification: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: null
        };
    }

    componentDidMount() {
        this.getDefaultNotificationsButtons();
    }

    getDefaultNotificationsButtons = () => {
        const { getDefaultNotificationsButtons, defaultButtons } = this.props;
        if (defaultButtons.size > 0) return;
        this.setState({ loading: true, error: null });
        getDefaultNotificationsButtons()
            .then(() => this.setState({ loading: false, error: null }))
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ loading: false, error: message });
            });
    };

    render() {
        const { addNotification, location } = this.props;
        const { loading, error } = this.state;
        return (
            <FHEContainer withBackIcon loading={loading} error={error} onClickFunc={this.getDefaultNotificationsButtons}>
                <FormNotification type={location.state === undefined ? 'add' : 'duplicate'} sendDataFunc={addNotification} />
            </FHEContainer>
        );
    }
}

function mapStateToProps(state) {
    return { defaultButtons: state.environments.fhe.data.Notifications.get('defaultButtons'), profile: state.data.user };
}

export default connect(
    mapStateToProps,
    dispatch => bindActionCreators(Object.assign({}, { addNotification, getDefaultNotificationsButtons }), dispatch)
)(NotificationAdd);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Notification/add.js